import { render, staticRenderFns } from "./LogisticsInfo.vue?vue&type=template&id=2aa0cdda&scoped=true"
import script from "./LogisticsInfo.vue?vue&type=script&lang=js"
export * from "./LogisticsInfo.vue?vue&type=script&lang=js"
import style0 from "./LogisticsInfo.vue?vue&type=style&index=0&id=2aa0cdda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0cdda",
  null
  
)

export default component.exports